var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/components/basic/TruvityLogo.tsx
import React from "react";
var TruvityLogo = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 190, height: 52, viewBox: "0 0 190 52", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M22.0567 36.86L23.26 42.8564C20.7246 43.288 18.9597 43.9125 15.1943 43.9125C7.65847 43.9125 6.23153 38.0848 6.23153 29.9497V24.5271L10.578 21.3589H0.263672V15.3045H6.2291V5.83607L12.6613 2.13742V15.3045H22.7227V21.3589H12.6613V32.6212C12.6613 35.2734 13.2398 37.9064 15.9454 37.9884C18.916 38.0824 22.0567 36.86 22.0567 36.86ZM42.853 15.0056C36.2896 16.5656 36.1024 22.5934 36.1024 22.5934H35.6576V15.3045H29.2278V43.2301H35.6576V32.2981C35.6576 20.1316 44.878 20.3992 48.4076 23.5457L51.9446 17.4866C49.9999 15.9652 46.3827 14.1689 42.853 15.0056ZM100.38 37.0794L92.898 15.3045H86.2203L96.3669 43.2301H104.048L115.556 15.3045H108.898L100.38 37.0794ZM182.773 15.3045L174.751 35.3916L167.677 15.3045H160.764L169.948 40.5779H172.359L167.692 51.9102H174.192L189.264 15.3094L182.773 15.3045ZM149.253 37.9956C146.548 37.9136 145.969 35.2758 145.969 32.6284V21.3589H156.031V15.3045H145.969V2.13742L139.537 5.83607V15.3045H133.572V21.3589H143.886L139.537 24.5222V29.9449C139.537 38.08 140.967 43.9076 148.5 43.9076C152.265 43.9076 154.028 43.2832 156.566 42.8516L155.365 36.8551C155.365 36.8551 152.222 38.0824 149.253 37.9956ZM74.496 29.2673C74.496 37.8099 66.8703 37.4893 66.8703 37.4893C62.6965 37.4893 61.4664 33.4313 61.4664 29.2673V15.3045H55.0343V30.878C55.0343 38.0631 58.5761 44.0403 66.5737 43.5508C72.2815 43.2012 74.0901 37.0094 74.0901 37.0094H74.496V43.2301H80.9282V15.3045H74.496V29.2673ZM120.941 43.2301H127.373V15.3045H120.941V43.2301ZM124.157 0.910156C123.34 0.910156 122.541 1.15055 121.861 1.60095C121.181 2.05134 120.652 2.6915 120.339 3.44048C120.026 4.18945 119.944 5.01361 120.104 5.80871C120.263 6.60382 120.657 7.33418 121.235 7.90742C121.813 8.48066 122.549 8.87104 123.351 9.0292C124.152 9.18736 124.983 9.10619 125.738 8.79595C126.493 8.48571 127.139 7.96035 127.593 7.28629C128.047 6.61223 128.289 5.81975 128.289 5.00906C128.289 3.92196 127.854 2.87939 127.079 2.1107C126.304 1.342 125.253 0.910156 124.157 0.910156Z",
    fill: "#005AD7"
  }
));

// src/components/basic/AppHeader/AppHeader.tsx
import React5 from "react";
import { Box as Box3, Stack, Toolbar } from "@mui/material";

// src/components/basic/MenuLink.tsx
import React2 from "react";
import { Link, Box } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
var MenuLink = (props) => {
  const content = /* @__PURE__ */ React2.createElement(Box, { component: "span", display: "inline-flex", alignItems: "center" }, props.children, props.target === "_blank" && /* @__PURE__ */ React2.createElement(OpenInNewIcon, { fontSize: "inherit", sx: { ml: ".3rem" } }));
  if (props.Link) {
    return /* @__PURE__ */ React2.createElement(Link, { component: props.Link, to: props.to, target: props.target }, content);
  }
  return /* @__PURE__ */ React2.createElement(Link, { href: props.to, target: props.target, underline: "none" }, content);
};

// src/components/basic/AppHeader/components/Logo.tsx
import React3 from "react";
var Logo = () => /* @__PURE__ */ React3.createElement(TruvityLogo, { width: void 0, height: 32 });

// src/components/basic/AppHeader/components/LogoWrapper.tsx
import React4 from "react";
var LogoWrapper = ({ children }) => /* @__PURE__ */ React4.createElement(React4.Fragment, null, children);

// src/components/basic/AppHeader/AppHeader.styled.tsx
import { AppBar, Box as Box2, styled } from "@mui/material";
var AppBarStyled = styled(AppBar)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  background: theme.palette.background.default
}));
var EmptiableBox = styled(Box2)({
  "&:empty": {
    display: "none"
  }
});

// src/components/basic/AppHeader/AppHeader.tsx
var AppHeader = ({
  links,
  secondaryLinks,
  topSlot,
  rightSlot,
  slotComponents: {
    Logo: Logo2 = Logo,
    LogoWrapper: LogoWrapper2 = LogoWrapper,
    MenuLink: MenuLink2 = MenuLink,
    Link: Link2
  } = {}
}) => {
  const renderLinks = (items) => /* @__PURE__ */ React5.createElement(React5.Fragment, null, items == null ? void 0 : items.map((item, i) => (
    /**
     * We use index as the `key` since none of the other `item` props can uniquely
     * identify the item.
     */
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ React5.createElement(MenuLink2, { key: i, to: item.to, target: item.target, Link: Link2 }, item.title)
  )));
  const renderTopSlot = () => {
    if (!topSlot) return null;
    return /* @__PURE__ */ React5.createElement(EmptiableBox, { margin: "4px" }, topSlot);
  };
  const renderRightSlot = () => {
    if (!rightSlot) return null;
    return /* @__PURE__ */ React5.createElement(EmptiableBox, { ml: 3, display: "flex", alignItems: "center" }, rightSlot);
  };
  return /* @__PURE__ */ React5.createElement(AppBarStyled, { elevation: 0, position: "sticky" }, renderTopSlot(), /* @__PURE__ */ React5.createElement(Toolbar, null, /* @__PURE__ */ React5.createElement(Box3, { mr: 3, display: "flex", alignItems: "center" }, /* @__PURE__ */ React5.createElement(LogoWrapper2, null, /* @__PURE__ */ React5.createElement(Logo2, null))), /* @__PURE__ */ React5.createElement(Stack, { direction: "row", alignItems: "center", spacing: 2, mr: 3, "data-testid": "primary-link" }, renderLinks(links)), /* @__PURE__ */ React5.createElement(Stack, { direction: "row", alignItems: "center", spacing: 2, ml: "auto", "data-testid": "secondary-link" }, renderLinks(secondaryLinks)), renderRightSlot()));
};

// src/components/basic/AppFooter/AppFooter.tsx
import React6 from "react";
import { Box as Box4, Stack as Stack2, Toolbar as Toolbar2 } from "@mui/material";
var isLinkItemParams = (item) => "to" in item;
var year = (/* @__PURE__ */ new Date()).getFullYear();
var AppFooter = ({ items, slotComponents: { Link: Link2 } = {} }) => /* @__PURE__ */ React6.createElement(Toolbar2, null, /* @__PURE__ */ React6.createElement(Box4, { mr: 3 }, "\xA9 ", year, " Truvity"), /* @__PURE__ */ React6.createElement(Stack2, { direction: "row", alignItems: "center", spacing: 2 }, items == null ? void 0 : items.map((item, i) => {
  const key = i;
  if (isLinkItemParams(item)) {
    return /* @__PURE__ */ React6.createElement(MenuLink, { key, to: item.to, target: item.target, Link: Link2 }, item.title);
  }
  return /* @__PURE__ */ React6.createElement(Box4, { key, display: "flex", alignItems: "center" }, item.content);
})));

// src/components/basic/DeploymentBanner/DeploymentBanner.tsx
import React7 from "react";
import Alert from "@mui/material/Alert";
import Markdown from "react-markdown";

// src/components/basic/DeploymentBanner/DeploymentBanner.styles.tsx
import { styled as styled2 } from "@mui/material";
var BannerMarkdownStyled = styled2("div")({
  display: "flex",
  flexDirection: "column",
  // Banner content should be compact, so we remove all margins from top-level elements
  "& > *": {
    margin: 0
  }
});

// src/components/basic/DeploymentBanner/DeploymentBanner.tsx
var markdownComponents = {
  a(props) {
    var _a;
    return /* @__PURE__ */ React7.createElement(MenuLink, { to: (_a = props.href) != null ? _a : "/", target: "_blank" }, props.children);
  }
};
var DeploymentBanner = ({ text }) => {
  if (!text) return null;
  return /* @__PURE__ */ React7.createElement(Alert, { severity: "warning" }, /* @__PURE__ */ React7.createElement(BannerMarkdownStyled, null, /* @__PURE__ */ React7.createElement(Markdown, { components: markdownComponents }, text)));
};

// src/components/specific/DemoAppHeader.tsx
import React9 from "react";
import Logout from "@mui/icons-material/Logout";

// src/components/specific/AccountMenu.tsx
import React8 from "react";
import { Box as Box5, Avatar, Menu, MenuItem, IconButton, Tooltip, Divider, ListItemIcon } from "@mui/material";
var AccountMenu = ({ items }) => {
  const [anchorEl, setAnchorEl] = React8.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement(Box5, { sx: { display: "flex", alignItems: "center", textAlign: "center" } }, /* @__PURE__ */ React8.createElement(Tooltip, { title: "Account settings" }, /* @__PURE__ */ React8.createElement(
    IconButton,
    {
      onClick: handleClick,
      size: "small",
      sx: { ml: 2 },
      "aria-controls": open ? "account-menu" : void 0,
      "aria-haspopup": "true",
      "aria-expanded": open ? "true" : void 0
    },
    /* @__PURE__ */ React8.createElement(Avatar, { sx: { width: 32, height: 32 } }, "A")
  ))), /* @__PURE__ */ React8.createElement(
    Menu,
    {
      anchorEl,
      id: "account-menu",
      open,
      onClose: handleClose,
      onClick: handleClose,
      PaperProps: {
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1
          },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0
          }
        }
      },
      transformOrigin: { horizontal: "right", vertical: "top" },
      anchorOrigin: { horizontal: "right", vertical: "bottom" }
    },
    items.map((item, i) => {
      if (item === "divider") {
        return /* @__PURE__ */ React8.createElement(Divider, { key: i });
      }
      return (
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ React8.createElement(MenuItem, { key: i, onClick: item.onSelect }, /* @__PURE__ */ React8.createElement(ListItemIcon, null, item.icon), item.title)
      );
    })
  ));
};

// src/components/specific/DemoAppHeader.tsx
var DemoAppHeader = ({
  links,
  docsUrl,
  adminPanelUrl,
  onLogout,
  deploymentBannerMarkdownText,
  LogoWrapper: LogoWrapper2
}) => /* @__PURE__ */ React9.createElement(
  AppHeader,
  {
    links,
    secondaryLinks: [
      {
        title: "Admin Panel",
        to: adminPanelUrl,
        target: "_blank"
      },
      {
        title: "Documentation",
        to: docsUrl,
        target: "_blank"
      }
    ],
    topSlot: /* @__PURE__ */ React9.createElement(DeploymentBanner, { text: deploymentBannerMarkdownText }),
    rightSlot: /* @__PURE__ */ React9.createElement(
      AccountMenu,
      {
        items: [
          {
            title: "Logout",
            icon: /* @__PURE__ */ React9.createElement(Logout, null),
            onSelect: onLogout
          }
        ]
      }
    ),
    slotComponents: { LogoWrapper: LogoWrapper2 }
  }
);

// src/components/specific/AdminAppHeader.tsx
import React10 from "react";
import Logout2 from "@mui/icons-material/Logout";
var AdminAppHeader = ({
  links,
  docsUrl,
  demoGalleryUrl: _demoGalleryUrl,
  accountMenuItems,
  onLogout,
  LogoWrapper: LogoWrapper2,
  deploymentBannerMarkdownText
}) => /* @__PURE__ */ React10.createElement(
  AppHeader,
  {
    links,
    secondaryLinks: [
      // TODO: enable back once the demo will be fixed
      // {
      //     title: 'Demo Gallery',
      //     to: demoGalleryUrl,
      //     target: '_blank',
      // },
      {
        title: "Documentation",
        to: docsUrl,
        target: "_blank"
      }
    ],
    topSlot: /* @__PURE__ */ React10.createElement(DeploymentBanner, { text: deploymentBannerMarkdownText }),
    rightSlot: /* @__PURE__ */ React10.createElement(
      AccountMenu,
      {
        items: [
          ...accountMenuItems ? [...accountMenuItems, "divider"] : [],
          {
            title: "Logout",
            icon: /* @__PURE__ */ React10.createElement(Logout2, null),
            onSelect: onLogout
          }
        ]
      }
    ),
    slotComponents: { LogoWrapper: LogoWrapper2 }
  }
);

// src/components/specific/DemoAppFooter.tsx
import React12 from "react";

// src/components/specific/AppFooterWithSharedLinks.tsx
import React11 from "react";
var AppFooterWithSharedLinks = ({ items, slotComponents, statusPageUrl }) => {
  const links = (items != null ? items : []).concat([
    {
      to: statusPageUrl,
      title: "Status",
      target: "_blank"
    }
  ]);
  return /* @__PURE__ */ React11.createElement(AppFooter, { items: links, slotComponents });
};

// src/components/specific/DemoAppFooter.tsx
var DemoAppFooter = ({ items, Link: Link2, statusPageUrl }) => /* @__PURE__ */ React12.createElement(AppFooterWithSharedLinks, { items, slotComponents: { Link: Link2 }, statusPageUrl });

// src/components/specific/AdminAppFooter.tsx
import React13 from "react";
var AdminAppFooter = ({ items, Link: Link2, statusPageUrl }) => /* @__PURE__ */ React13.createElement(AppFooterWithSharedLinks, { items, slotComponents: { Link: Link2 }, statusPageUrl });

// src/components/specific/SignUpAppHeader.tsx
import React14 from "react";
var SignUpAppHeader = ({ LogoWrapper: LogoWrapper2 }) => /* @__PURE__ */ React14.createElement(AppHeader, { slotComponents: { LogoWrapper: LogoWrapper2 } });

// src/components/specific/SignUpAppFooter.tsx
import React15 from "react";
var SignUpAppFooter = ({ items, Link: Link2, statusPageUrl }) => /* @__PURE__ */ React15.createElement(AppFooterWithSharedLinks, { items, slotComponents: { Link: Link2 }, statusPageUrl });

// src/components/modules/CookieBotCookieDeclaration.tsx
import React16, { useEffect, useRef } from "react";
var CookieBotCookieDeclaration = () => {
  const containerRef = useRef(null);
  const cbid = __COOKIEBOT_CBID__;
  useEffect(() => {
    const container = containerRef.current;
    const script = document.createElement("script");
    script.id = "CookieDeclaration";
    script.type = "text/javascript";
    script.src = `https://consent.cookiebot.com/${cbid}/cd.js`;
    script.async = true;
    container == null ? void 0 : container.appendChild(script);
    return () => {
      if (!container) return;
      container.innerHTML = "";
    };
  }, [cbid]);
  return /* @__PURE__ */ React16.createElement("div", { ref: containerRef });
};

// src/components/modules/Table/Table.tsx
import React22 from "react";
import { Alert as Alert2, LinearProgress } from "@mui/material";

// src/components/modules/Table/components/basic/DataGridNoRowsOverlay.tsx
import React17 from "react";
import { Stack as Stack3 } from "@mui/material";
var DataGridNoRowsOverlay = () => /* @__PURE__ */ React17.createElement(Stack3, { height: "100%", alignItems: "center", justifyContent: "center" }, "No data available.");

// src/components/modules/Table/components/basic/DataGridNoResultsOverlay.tsx
import React18 from "react";
import { Stack as Stack4 } from "@mui/material";
var DataGridNoResultsOverlay = () => /* @__PURE__ */ React18.createElement(Stack4, { height: "100%", alignItems: "center", justifyContent: "center" }, "No items for current filter.");

// src/components/modules/Table/components/specific/ClientPaginationTable.tsx
import React19 from "react";

// src/components/modules/Table/hooks/usePersistence.tsx
import { create } from "zustand";
import { persist } from "zustand/middleware";
var usePersistence = (tableName) => {
  const store = create()(
    persist(
      (set) => ({
        rowsPerPage: null,
        setRowsPerPage: (newRowsPerPage) => set({
          rowsPerPage: newRowsPerPage
        })
      }),
      {
        name: tableName
      }
    )
  );
  return store;
};

// src/components/modules/Table/utils/converter.ts
var convertColumns = (columns) => columns.map((_a) => {
  var _b = _a, { field, renderCell } = _b, restOfColumn = __objRest(_b, ["field", "renderCell"]);
  return __spreadProps(__spreadValues({}, restOfColumn), {
    renderCell: renderCell ? (params) => renderCell(__spreadProps(__spreadValues({}, params), { row: params.row })) : void 0,
    field: String(field)
  });
});

// src/components/modules/Table/components/specific/DataGrid.styled.tsx
import { styled as styled3 } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
var DataGridStyled = styled3(DataGrid)(() => ({
  width: "100%",
  '& [data-field="actions"]': {
    "&:focus, &:focus-within": {
      outline: "none"
    }
  },
  ".MuiDataGrid-row": {
    cursor: "pointer"
  },
  "& .MuiDataGrid-virtualScroller": {
    minHeight: "50px"
  }
}));

// src/components/modules/Table/components/specific/ClientPaginationTable.tsx
var ClientPaginationTable = ({
  isLoading,
  rows,
  columns,
  onRowClick,
  pageSize,
  tableId,
  slots: slots2
}) => {
  const tablePersistence = usePersistence(tableId);
  const rowsPerPage = tablePersistence((state) => state.rowsPerPage);
  const setRowsPerPage = tablePersistence((state) => state.setRowsPerPage);
  return /* @__PURE__ */ React19.createElement(
    DataGridStyled,
    {
      slots: slots2,
      loading: isLoading,
      rows,
      initialState: {
        pagination: { paginationModel: { pageSize: rowsPerPage !== null ? rowsPerPage : pageSize } }
      },
      pageSizeOptions: [...new Set([pageSize, 25, 100].sort((a, b) => a - b))],
      onPaginationModelChange: (model) => {
        setRowsPerPage(model.pageSize);
      },
      columns: convertColumns(columns),
      onRowClick: (params) => {
        onRowClick && onRowClick(params.row);
      }
    }
  );
};

// src/components/modules/Table/components/specific/ServerPaginationTable.tsx
import React21 from "react";

// src/components/modules/Table/components/basic/CustomPaginationFooter.tsx
import React20 from "react";
import IconButton2 from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";

// src/components/modules/Table/types.ts
var NavigationDirection = {
  first: "first",
  prev: "prev",
  next: "next",
  last: "last"
};

// src/components/modules/Table/components/basic/CustomPaginationFooter.tsx
var CustomPaginationFooter = ({ activeButtons, rowsPerPage, onClick }) => /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement("span", null, "Rows per page: ", rowsPerPage), /* @__PURE__ */ React20.createElement(
  IconButton2,
  {
    color: "primary",
    "aria-label": "go to first page",
    disabled: !activeButtons.hasFirst,
    onClick: () => onClick(NavigationDirection.first)
  },
  /* @__PURE__ */ React20.createElement(FirstPageIcon, null)
), /* @__PURE__ */ React20.createElement(
  IconButton2,
  {
    color: "primary",
    "aria-label": "got to previous page",
    disabled: !activeButtons.hasPrev,
    onClick: () => onClick(NavigationDirection.prev)
  },
  /* @__PURE__ */ React20.createElement(ChevronLeftIcon, null)
), /* @__PURE__ */ React20.createElement(
  IconButton2,
  {
    color: "primary",
    "aria-label": "go to next page",
    disabled: !activeButtons.hasNext,
    onClick: () => onClick(NavigationDirection.next)
  },
  /* @__PURE__ */ React20.createElement(ChevronRightIcon, null)
), /* @__PURE__ */ React20.createElement(
  IconButton2,
  {
    color: "primary",
    "aria-label": "got to last page",
    disabled: !activeButtons.hasLast,
    onClick: () => onClick(NavigationDirection.last)
  },
  /* @__PURE__ */ React20.createElement(LastPageIcon, null)
));

// src/components/modules/Table/components/specific/ServerPaginationTable.tsx
var ServerPaginationTable = ({
  isLoading,
  rows,
  columns,
  onRowClick,
  pageSize,
  slots: slots2,
  serverPagination
}) => {
  const CustomPagination = () => /* @__PURE__ */ React21.createElement(
    CustomPaginationFooter,
    {
      activeButtons: serverPagination.info,
      rowsPerPage: rows.length,
      onClick: serverPagination.onNavigationChange
    }
  );
  return /* @__PURE__ */ React21.createElement(
    DataGridStyled,
    {
      slots: __spreadProps(__spreadValues({}, slots2), {
        pagination: CustomPagination
      }),
      loading: isLoading,
      rowCount: pageSize,
      rows,
      columns: convertColumns(columns),
      onRowClick: (params) => {
        onRowClick && onRowClick(params.row);
      },
      pageSizeOptions: [pageSize],
      paginationMode: "server",
      filterMode: "server",
      sortingMode: "server",
      onSortModelChange: serverPagination.onSortChange,
      onFilterModelChange: (model, details) => {
        if (details.reason && serverPagination.onFilterChange) serverPagination.onFilterChange(model);
      }
    }
  );
};

// src/components/modules/Table/Table.tsx
var slots = {
  loadingOverlay: () => /* @__PURE__ */ React22.createElement(LinearProgress, null),
  noRowsOverlay: DataGridNoRowsOverlay,
  noResultsOverlay: DataGridNoResultsOverlay
};
var Table = (_a) => {
  var _b = _a, {
    isError,
    isLoading,
    isRefetching,
    rows,
    columns,
    onRowClick,
    pageSize = 25
  } = _b, otherProps = __objRest(_b, [
    "isError",
    "isLoading",
    "isRefetching",
    "rows",
    "columns",
    "onRowClick",
    "pageSize"
  ]);
  if (isError) {
    return /* @__PURE__ */ React22.createElement(Alert2, { severity: "error" }, "Encountered an unknown error");
  }
  if ("serverPagination" in otherProps) {
    return /* @__PURE__ */ React22.createElement(
      ServerPaginationTable,
      {
        pageSize,
        slots,
        isLoading: isLoading || isRefetching,
        rows,
        columns,
        serverPagination: otherProps.serverPagination,
        onRowClick
      }
    );
  }
  return /* @__PURE__ */ React22.createElement(
    ClientPaginationTable,
    {
      tableId: otherProps.tableId,
      pageSize,
      slots,
      isLoading: isLoading || isRefetching,
      rows,
      columns,
      onRowClick
    }
  );
};

// src/components/modules/Table/utils/columnFactory.ts
var createColumnFactory = () => {
  const columnFactory = (value) => value;
  return columnFactory;
};
export {
  AccountMenu,
  AdminAppFooter,
  AdminAppHeader,
  AppFooter,
  AppHeader,
  CookieBotCookieDeclaration,
  DemoAppFooter,
  DemoAppHeader,
  DeploymentBanner,
  MenuLink,
  NavigationDirection,
  SignUpAppFooter,
  SignUpAppHeader,
  Table,
  TruvityLogo,
  createColumnFactory
};
//# sourceMappingURL=index.mjs.map